import * as d3 from 'd3';

/**
 * Generates data points and groups them by series.
 *
 * @param {Function} x - A function that maps a date to an x-coordinate.
 * @param {Function} y - A function that maps a count to a y-coordinate.
 * @param {Array} data - An array of data objects, each containing `date`, `count`, and `display_name` properties.
 * @returns {[Array, Map]} - A tuple where the first element is an array of points in the format [x, y, z, date, count],
 *                           and the second element is a Map where the keys are series names and the values are arrays of points.
 */
export function gen_data_group(x, y, data) {
    // Compute the points in pixel space as [x, y, z], where z is the name of the series.
    const points = data.map((d) => [x(d.date), y(d.count), d.display_name, d.date, d.count]);

    // Group the points by series.
    const groups = d3.rollup(points, v => Object.assign(v, {z: v[0][2]}), d => d[2]);
    
    return [points, groups]
}